/// <amd-module name="Test/TestPlansHubRefresh/TestHub/Constants" />

export class TelemetryConstants {
    public static GET_TEST_SUITES_FOR_PLAN = "GetTestSuitesForPlan";
    public static GET_TEST_POINTS_FOR_SUITE = "GetTestPointsForSuite";
    public static OPEN_TEST_RESULT = "OpenTestResult";
    public static OPEN_TEST_CASE_RESULTS_PANEL = "OpenTestCaseResultsPanel";
    public static OPEN_TEST_EXECUTION_HISTORY = "OpenTestExecutionHistory";
    public static EDIT_TEST_SUITE_USING_FORM = "EditTestSuiteUsingForm";
    public static OEPN_TEST_SUITE_USING_FORM = "OpenTestSuiteUsingForm";
    public static GET_TEST_CASES_FOR_SUITE = "GetTestCasesForSuite";
    public static ADD_TEST_CASE_USING_FORM = "AddTestCaseUsingForm";
    public static EDIT_TEST_CASE_USING_FORM = "EditTestCaseUsingForm";
    public static BULK_EDIT_TEST_CASES = "BulkEditTestCases";
    public static ADD_EXISTING_TEST_CASES = "AddExistingTestCases";
    public static REORDER_TEST_CASES = "ReorderTestCases";
    public static BULK_MARK_TEST_OUTCOME = "BulkMarkTestOutcome";
    public static BULK_MARK_ASSIGN_TESTER: string = "BulkMarkAssignTester";
    public static LAUNCH_APPLICATION_TEST_RUNNER = "LaunchApplicationTestRunner";
    public static LAUNCH_APPLICATION_TEST_RUNNER_FAILURE = "LaunchApplicationTestRunnerFailure";
    public static LAUNCH_APPLICATION_TEST_RUNNER_TO_RESUME_TEST = "LaunchApplicationTestRunnerToResumeTest";
    public static LAUNCH_WEB_RUNNER = "LaunchWebRunner";
    public static LAUNCH_RUN_WITH_OPTIONS_WEB_RUNNER = "LaunchRunWithOptionsWebRunner";
    public static RESUME_TEST = "ResumeTest";
    public static PIVOT_CHANGED = "PivotChanged";
    public static ASSIGN_CONFIGURATION_TO_TEST_CASE = "AssignConfigurationToTestCase";
    public static TOGGLE_FAVORITE = "ToggleFavorite";
    public static FETCH_FAVORITE = "FetchFavorites";
    public static CHANGE_TEST_PLAN = "ChangeTestPlan";
    public static NEW_SUITE = "NewSuite";
    public static REORDER_TEST_SUITE = "ReorderTestSuite";
    public static MOVE_TEST_CASES_TO_SUITE = "MoveTestCasesToSuite";
    public static EXPORT_HTML = "ExportHTML";
    public static EDIT_SUITE_QUERY = "EditQuery";
    public static DELETE_SUITE: string = "DeleteSuite";
    public static RENAME_TEST_SUITE = "RenameTestSuite";
    public static RENAME_TEST_SUITE_KEYBOARD = "RenameTestSuiteKeyboard";
    public static CLICK_COPY_TEST_PLAN_OPTION = "ClickCopyTestPlanOption";
    public static COPY_TEST_PLAN = "CopyTestPlan";
    public static CLONE_TEST_CASES = "CloneTestCases";
    public static IMPORT_TEST_SUITE = "ImportTestSuite";
    public static CLICK_TEST_PLAN_SETTINGS = "ClickTestPlanSettings";
    public static CHANGE_TEST_PLAN_SETTINGS = "ChangeTestPlanSettings";
    public static RESUME_WITH_WEB_RUNNER = "ResumeTestWithWebRunner";
    public static AUTOMATED_TEST_RUN = "AutomatedTestRun";
    public static RUN_WITH_OLD_MTM = "RunTestUsingOldMTM";
    public static RUN_WITH_NEW_MTM = "RunTestUsingNewMTM";

    public static COLUMN_OPTIONS_EDIT = "ColumnOptionsEdit";

    public static FILTER_TOGGLED = "FilterToggled";
    public static FILTER_VALUES_CHANGED = "FilterValuesChanged";

    public static TEST_HUB_FEATURE_AREA_NAME = "TestManagement";
    public static AUTHOR_PIVOT_PAGE_LOAD_TTI_SCENARIO = "TestPlansAuthorPivotTTI";
    public static EXECUTE_PIVOT_PAGE_LOAD_TTI_SCENARIO = "TestPlansExecutePivotTTI";
    public static TESTPLAN_CHANGE_TTI_SCENARIO = "TestPlanChangeTTI";

    public static REMOVE_TEST_CASES = "RemoveTestCasesFromSuite";

    public static NAVIGATE_TO_PROGRESS_REPORT_FROM_TEST_HUB_REFRESH = "NavigateToProgressReportFromTestHubRefresh";
    public static NAVIGATE_TO_PROGRESS_REPORT_FROM_TEST_HUB_REFRESH_ERROR = "NavigateToProgressReportFromTestHubRefreshError";

    public static ADD_EXISTING_TEST_CASES_USING_KEYBOARD = "AddExistingTestCasesUsingKeyboard";
    public static ADD_TEST_CASES_USING_KEYBOARD = "AddTestCasesUsingKeyboard";

    public static GRID_VIEW_SELECTED = "GridViewSelected";
    public static AUTHOR_PIVOT_TEST_CASE_FIELDS_MISSING = "AuthorPivotTestCaseFieldsMissing";
    public static TEST_CASE_LINKED_ITEMS = "Show Test Case Linked Items";
    public static ASSIGN_TESTERS_TO_SUITE = "Assign testers to run all tests";

    public static HELP_TEST_PLANS_PAGE = "HelpButtonClicked";
    public static TEST_CASE_LINKED_WORKITEMS = "ShowTestCaseLinkedRequirementsAndBugs";

    public static SAGA_ERROR = "RootSagaError";
    public static EXPORT_TESTCASES = "ExportTestCases";
    public static EXPORT_TESTCASES_FAILURE = "ExportTestCasesFailure";
    public static CLICK_EXPORT_TESTCASES = "ClickExportTestCases";
    public static SELECT_FILE_IMPORT_TESTCASES = "SelectFileForImportTestCases";
    public static CLICK_IMPORT_TESTCASES = "ClickImportTestCases";
    public static IMPORT_TESTCASES_COMPLETED = "ImportTestCasesCompleted";
    public static IMPORT_TESTCASES_ERROR = "ImportTestCasesError";
    public static TOGGLE_TEST_CASE_PREVIEW = "ToggleTestCasePreview";
    public static FILTER_TESTSUITE_TREE = "FilterTestSuiteTree";
    public static IMPORTSUITE_TESTPLAN_DROPDOWN_SELECTION = "ImportSuiteTestPlanDropdownSelection";
    public static IMPORTSUITE_TESTPLAN_ID_SEARCH = "ImportSuiteTestPlanIdSearch";
    public static IMPORT_TESTPLAN_SELECTION_ERROR = "ImportSuiteTestPlanSelectionError";
    public static IMPORTSUITE_TESTSUITE_DROPDOWN_SELECTION = "ImportSuiteTestSuiteDropdownSelection";
    public static IMPORTSUITE_TESTSUITE_ID_SEARCH = "ImportSuiteTestSuiteIdSearch";
    public static IMPORT_TESTSUITE_SELECTION_ERROR = "ImportSuiteTestSuiteSelectionError";
    public static COPYTESTCASES_TESTPLAN_DROPDOWN_SELECTION = "CopyTestCasesTestPlanDropdownSelection";
    public static COPYTESTCASES_TESTPLAN_ID_SEARCH = "CopyTestCasesTestPlanIdSearch";
    public static COPYTESTCASES_TESTPLAN_SELECTION_ERROR= "CopyTestCasesTestPlanSelectionError";
    public static COPYTESTCASES_TESTSUITE_DROPDOWN_SELECTION = "CopyTestCasesTestSuiteDropdownSelection";
    public static COPYTESTCASES_TESTSUITE_ID_SEARCH = "CopyTestCasesTestSuiteIdSearch";
    public static COPYTESTCASES_TESTSUITE_SELECTION_ERROR = "CopyTestCasesTestSuiteSelectionError";
}

export class TestHubRefreshConstants {
    public static PIVOT_ID = "pivots";
    public static DEFINE_TAB_ID = "define";
    public static EXECUTE_TAB_ID = "execute";
    public static CHART_TAB_ID = "charts";

    public static AUTHOR_TEXT_FILTER_ITEM_KEY = "authorFilterText";
    public static AUTHOR_ASSIGNEDTO_FILTER_ITEM_KEY = "authorAssignedToFilter";
    public static AUTHOR_STATE_FILTER_ITEM_KEY = "authorStateFilter";

    public static EXECUTE_TEXT_FILTER_ITEM_KEY = "executeFilterText";
    public static EXECUTE_OUTCOME_FILTER_ITEM_KEY = "executeOutcomeFilter";
    public static EXECUTE_TESTER_FILTER_ITEM_KEY = "executeTesterFilter";
    public static EXECUTE_CONFIGURATION_FILTER_ITEM_KEY = "executeConfigurationFilter";
    public static EXECUTE_ASSIGNEDTO_FILTER_ITEM_KEY = "executeAssignedToFilter";
    public static EXECUTE_STATE_FILTER_ITEM_KEY = "executeStateFilter";

    public static QUERY_PARAM_PLAN_ID = "planId";
    public static QUERY_PARAM_SUITE_ID = "suiteId";
    public static QUERY_PARAM_OP_ID = "opId";

    public static SETTINGS_PATH = "TestPlansHubRefresh";
    public static PREVIEW_SPLITTER_STATUS_KEY = `${TestHubRefreshConstants.SETTINGS_PATH}/PreviewSplitterStatus`;
    public static PREVIEW_SPLITTER_SIZE_KEY = `${TestHubRefreshConstants.SETTINGS_PATH}/PreviewSplitterSize`;
    public static SETTINGS_KEY = "setting";

    public static INITIAL_PAGE_SIZE = "25";
    public static INT_MIN_VALUE = "-2147483648";
    public static PAGE_SIZE = "1000";
    public static FETCH_TESTPLANS_PAGE_SIZE = 200;

    public static TOAST_MESSAGE_DURATION = 3000;

    public static ERROR_TOAST_DURATION = 8000;

    public static LONG_TOAST_MESSAGE_DURATION = 5000;

    public static LARGE_DATASET_COUNT_THRESHOLD = 10000;

    public static DEFAULT_SUITE_COUNT_THRESHOLD = 500;

    public static RIGHT_MOUSE_BUTTON = 2;

    public static BREADCRUMB_PRIRORITY = 5;

    public static WorkItemField_State = "System.State";
    public static WorkItemField_AssignedTo = "System.AssignedTo";
    public static WorkItemField_Ttile = "System.Title";
    public static WorkItemField_Id = "System.Id";
    public static SharedStepWorkItemType = "Shared Steps";
    public static TestCaseWorkItemType = "Test Case";
    public static WorkItemField_Tags = "System.Tags";

    public static EmptyGuid = "00000000-0000-0000-0000-000000000000";
    public static NoPlanImagePath = "ms.vss-test-web/testplan-hub-refresh-assets/zero-data-no-plan-image.png";
    public static testPlanAll = "all";
    public static allMineRouteContributionId = "ms.vss-test-web.test-mine-directory-route";

    public static DocLinkNewTestPlansPage = "https://aka.ms/newtestplanspage";
    public static RenameTestSuite = "RenameTestSuite";

    public static EnableThirdPartyTabContributionsFF = "WebAccess.TestManagement.TestPlansHubRefresh.EnableThirdPartyTabContributions";
    public static EnableThirdPartyMenuContributionsFF = "WebAccess.TestManagement.TestPlansHubRefresh.EnableThirdPartyMenuContributions";
    public static EnableToastNotificationsForSagaErrorFF = "WebAccess.TestManagement.TestPlansHubRefresh.EnableToastNotificationsForSagaError";
    public static BulkCreateRequirementBasedSuitesFF = "WebAccess.TestManagement.TestPlansHubRefresh.BulkCreateRequirementBasedSuites";
    public static ShowLargeDatasetToastFF = "WebAccess.TestManagement.TestPlansHubRefresh.ShowLargeDatasetToast";
    public static FetchTestPointColumnOptionsRecursively = "WebAccess.TestManagement.TestPlansHubRefresh.FetchTestPointColumnOptionsRecursively";
    public static DisableEntityCountFF = "WebAccess.TestManagement.TestPlansHubRefresh.DisableEntityCountFeature";
    public static SortPlansAndSuitesAlphabeticallyFF = "WebAccess.TestManagement.SortPlansAndSuitesAlphabetically";
    public static EnableEditableDropdownForImportingTestSuiteAndCopyingTestCasesFF = "WebAccess.TestManagement.TestPlansHubRefresh.EnableEditDropdownToImportTestSuiteAndCopyTestCase";
    public static ShowDTRUpdateMsgLaunchDialog = "WebAccess.TestManagement.TestPlansHubRefresh.ShowDTRUpdateMsgLaunchDialog";
}

export namespace PreviewSplitterOptions {
    // Using right instead of on here to avoid multiple changes in the future if we enable the bottom preview for users
    export const RIGHT = "Right";
    export const OFF = "Off";
}

export namespace RouteParametersMineAllPage {
    export const ContributionId = "ms.vss-test-web.test-mine-directory-route";
    export const Pivot = "all";
    export const queryParams = "?showFilters=true";
}

export class SuitesConstants {
    public static SUITE_TREE = "Suite Tree";
    public static TestSuitesLimit = 75;
    public static TestCaseDragItemType = "test-case-item";
    public static TestSuiteDragItemType = "test-suite-item";
}
